<template>
  <div>
    <div class="search-container">
    <el-input
      type="text"
      v-model="searchQuery"
      @input="performSearch"
      :placeholder="`${currentLanguage === 'hu' ? 'keresés': currentLanguage === 'en' ? 'search' : 'Suche nach'}`"
      @keyup.enter="getNewsAndProjects"
      class="search-input"
    />
    <button class="search-btn ion-search" @click="getNewsAndProjects"></button>
    </div>
    <div> <p style="font-size: 20px; font-weight: bold;">{{ currentLanguage === 'hu' ? 'Keresési eredmények:': currentLanguage === 'en' ? 'Search results:' : 'Suchergebnisse:' }}</p>
    </div>
     <ul v-if="results.length" class="results-list">
      <li v-for="(result, index) in results" :key="index" :class="index % 2 === 0 ? 'striped' : ''" 
       @click="openNewTab(result.slug_hu, result.type)"
        style="cursor: pointer;">
        <div>
          <i :class="getIcons(result.type)"></i>
          <strong>{{ currentLanguage === 'hu' ? result.title_hu : currentLanguage === 'en' ? result.title_en : result.title_de}}</strong>
        </div>
        <div style="padding-left:10px;">
            {{ formatDate(result.created_at) }}
        </div>
      </li>
    </ul>
    <p v-else>{{ currentLanguage === 'hu' ? 'Nincs találat': currentLanguage === 'en' ? 'No results' : 'Keine Ergebnisse' }}</p>
    <div id="map" v-if="view === 'map'"></div>
			<ul class="pagination" v-if="params.last_page > 1">
			    <li v-if="params.current_page > 1">
			    	<button @click="goToPage(params.current_page - 1)"><i class="ion-arrow-left-c"></i></button>
			    </li>
			    <li :class="'loaded'" v-for="number in params.last_page" :key="number">
				    <button @click="goToPage(number)" :class="activePage(number)">{{ number }}</button>
			    </li>
			    <li v-if="params.current_page < params.last_page">
			    	<button @click="goToPage(params.current_page + 1)"><i class="ion-arrow-right-c"></i></button>
			    </li>
			</ul>
		</div>
</template>

<script>

import axios from 'axios';

export default {
    mounted() {
        this.getNewsAndProjects();
    },
  data() {
    return {
      searchQuery: '',
      results: [],
      params: {
        page: 1,
        last_page: 1,
      },     
      currentLanguage: this.$route.params.lang || 'en',
      view: 'list',
      currentLanguage: window.currentLocale,
    };
  },
  methods: {
    
    performSearch() {
      if (this.searchQuery) {
        this.params.page = 1;
        this.getNewsAndProjects();
      } else {
        this.results = [];
      }
    },
    getNewsAndProjects() {
      const params = {
        page: this.params.page,
        lang: this.currentLanguage,
        'search-term': this.searchQuery,
        last_page: 1,
      };
      axios
        .get('/pa/news-and-projects', {
          params,
        })
        .then((resp) => {
          this.results = resp.data.data;
          this.params.last_page = resp.data.last_page;
          this.params.current_page = resp.data.current_page;
        })
        .catch((error) => {
          console.error('Error fetching news and projects:', error);
        });
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
     goToPage(pagenumber) {
                if(pagenumber < 1) return;
                if(pagenumber > this.params.last_page) return;
                this.params.page = pagenumber;
            	this.getNewsAndProjects();
    },
     activePage(pagenumber) {
                return this.params.current_page == pagenumber ? 'active'  : '';
    },
     toggleConcepts() {
				this.getNewsAndProjects();
      },
      toggleFilter() {
                this.params.current_page = 1;
                this.params.page = 1;
      },
      openNewTab(slug, type) {
        if (type === 'project') {
            switch (this.currentLanguage) {
                case 'hu':
                    window.open('/hu/projects/' + slug, '_blank');
                    break;
                case 'en':
                    window.open('/en/projects/' + slug, '_blank');
                    break;
                case 'de':
                    window.open('/de/projects/' + slug, '_blank');
                    break;
                default:
                    window.open('/en/projects/' + slug, '_blank');
            }
          }else if(type == '0') {
             window.open('/' + this.currentLanguage + '/news/' + slug, '_blank');
          }
           else {
           window.open('/' + this.currentLanguage + '/sustainability-news/' + slug, '_blank');
          }
        },

    getIcons(type) {
      switch (type) {
        case "project":
          return 'ion-ios-home';
        case "0":
        case "1":
          return 'ion-ios-book';
       
        default:
          return '';
      }
    }
  }, 
};
</script>

<style scoped>
.search-input {
  width: 70%;
  margin-bottom: 20px;
}

.results-list {
  list-style: none;
  padding: 0;
}

.results-list li {
  padding: 5px 0;
}

p {
  color: gray;
}

.search-btn {
		display: inline-block;
		height: 38px;
		width: 38px;
		margin-left: 5px;
		border-radius: 50%;
		border: none;
	}

.ion-search {
	font-size: 20px;
}

</style>
<style>

  input[type=text] {
  border: none;
  margin-bottom: 0px;
  padding:0px;
  height:35px;
  }

  .search-btn {
		height: 38px;
		width: 38px;
		margin-left: 5px;
		border-radius: 50%;
		border: none;
    display: flex;
    justify-content: center;
    align-items: center;
	}

  .search-container {
    display: flex;
    width:70%;
  }

  .search-input {
  flex: 1;
  width: 70%;
  margin-bottom: 0px;
  padding:0px;
  height:35px;
  }

.ion-search {
	font-size: 20px;
}

.results-list {
  list-style: none;
  padding: 0;
}

.results-list li {
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.results-list li.striped {
  background-color: #f9f9f9;
}

.ion-ios-home{
 font-size:20px;
 margin-left:10px;
}

.ion-ios-book{
   font-size:20px;
  margin-left:10px;
}

strong{
  padding-left:10px
}
</style>
